module.exports = __webpack_public_path__ + "img/24.62f9db60.gif";